import script from "./ClassRoomCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassRoomCard.vue?vue&type=script&setup=true&lang=js"

import "./ClassRoomCard.vue?vue&type=style&index=0&id=056568f0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056568f0"]])

export default __exports__